import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Rokojori } from "../Rokojori";
import { UserAccountBlock } from "./UserAccountBlock";
import { RokojoriWebsiteUserSystem } from "./UserSystem";

export class ConfirmSignup
{
  static readonly attribute = new ElementAttribute( "confirm-signup" );
  static readonly selector = new ElementSelector( UserAccountBlock.info, ConfirmSignup.attribute );

  static applyOnDocument()
  {
    ConfirmSignup.selector.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static async applyOnElement( e:Element )
  {
    let parameters = this.getURLParameters();
    
    if ( ! ( parameters.has( "id" ) && parameters.has( "token" ) ) )
    {
      this.setNoParams( e );
      return;
    }

    let id = parameters.get( "id" );
    let token = parameters.get( "token" );

    let signupResult = await Rokojori.$.userSystem.confirmSignup( id, token );
    
    if ( signupResult )
    {
      this.setSuccess( e );
    }
    else
    {
      this.setInvalid( e );
    }
  }

  static setNoParams( e:Element ) 
  { 
    e = new ElementType( "form-data" ).query( e );
    e.innerHTML = this.noParametersMessage;
  }

  static setInvalid( e:Element ) 
  { 
    e = new ElementType( "form-data" ).query( e );
    e.innerHTML = this.invalidMessage;
  }

  static setSuccess( e:Element )
  {
    e = new ElementType( "form-data" ).query( e );
    e.innerHTML = this.successMessage;
  }

  static getURLParameters(): Map<string, string> 
  {
    let parameters = new Map<string,string>();
    let queryString = window.location.search;
  
    let searchParams = new URLSearchParams( queryString );
  
    searchParams.forEach( ( value, key ) => { parameters.set( key, value ); } );
  
    return parameters;
  }

  static successMessage = 
  `    
    <landscape-only><br><br><br><br></landscape-only>
    <h1>Signup confirmed!</h1>
    You can <a href="::/en/user/login">login</a> now.
  `;

  static invalidMessage = 
  `
    <landscape-only><br><br><br><br></landscape-only>
    <h1>Sorry, signup failed...</h1>
    Please try again later
  `;

  static noParametersMessage = 
  `
    <form-data>
    <landscape-only><br><br><br><br></landscape-only>
    <h1>Sorry, wrong parameters</h1>
    Something went wrong, the url should have parameters
    </form-data>
  `;
}